import React from 'react';

const Eye = (props: object) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.2817 11C14.2817 12.815 12.8151 14.2817 11.0001 14.2817C9.18505 14.2817 7.71838 12.815 7.71838 11C7.71838 9.18499 9.18505 7.71832 11.0001 7.71832C12.8151 7.71832 14.2817 9.18499 14.2817 11Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 18.5808C14.2358 18.5808 17.2516 16.6741 19.3508 13.3741C20.1758 12.0816 20.1758 9.90914 19.3508 8.61664C17.2516 5.31664 14.2358 3.40997 11 3.40997C7.76415 3.40997 4.74831 5.31664 2.64915 8.61664C1.82415 9.90914 1.82415 12.0816 2.64915 13.3741C4.74831 16.6741 7.76415 18.5808 11 18.5808Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Eye;
